/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: metrics-dashboard-component.ts
 *
 * Created by randysorensen on 2019-02-13.
 */

function MetricsDashboardController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    loginService: JS5Object,
    BreadcrumbService: JS5Object,
    MetricsDashboardService: JS5Object,
    ModalService: JS5Object,
    NotificationService: JS5Object
) {

    const setupBreadcrumbs = () => {
        BreadcrumbService.clearBreadcrumbs();
        BreadcrumbService.addBreadcrumb({
            name: 'Metrics',
            location: '/dashboard/metrics',
        });
    };

    const setupToolbar = () => {
        this.toolbarButtonDefs = [
            {
                label: 'Export',
                icon: 'fa-download',
                enabled: () => true,
                onClick: MetricsDashboardService.exportDeliveryMetrics
            }
        ]
    };

    const buildPanelRows = () => {
        this.panelRows = [
            {
                currentMonthDataProperty: 'packagesDeliveredCurrentMonth',
                monthlyDatasetProperty: 'packagesDeliveredPerMonth',
                sumLabel: 'Total Packages Delivered',
                sumDataProperty: 'totalPackagesDelivered'
            },
            {
                currentMonthDataProperty: 'filesDeliveredCurrentMonth',
                monthlyDatasetProperty: 'filesDeliveredPerMonth',
                sumLabel: 'Total Files Delivered',
                sumDataProperty: 'totalFilesDelivered'
            },
            {
                currentMonthDataProperty: 'hoursDeliveredCurrentMonth',
                monthlyDatasetProperty: 'hoursDeliveredPerMonth',
                sumLabel: 'Total Hours Delivered',
                sumDataProperty: 'totalHoursDelivered'
            },
            {
                currentMonthDataProperty: 'terabytesDeliveredCurrentMonth',
                monthlyDatasetProperty: 'terabytesDeliveredPerMonth',
                sumLabel: 'Total File Size (TB) Delivered',
                sumDataProperty: 'totalTerabytesDelivered'
            }];
    };


    //===================//
    // Template Controls //
    //===================//

    this.onFilterButtonClick = ($event: JS5Object) => {
        $event.target.blur();
        $event.stopImmediatePropagation();
        ModalService.showMetricsFilterModal();
    };

    this.goToLogin = () => {
        $location.url('/login');
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.chromeless = !loginService.isAuthenticated();

        this.loadingIndicator = {
            backdrop: true,
            show: true,
            title: 'Working',
            message: 'Please wait...'
        };

        this.metricsData = {
            partnerRatioMap: {},
            packagesDeliveredPerMonth: {},
            filesDeliveredPerMonth: {},
            hoursDeliveredPerMonth: {},
            bytesDeliveredPerMonth: {},
            totalPackagesDelivered: 0,
            totalFilesDelivered: 0,
            totalHoursDelivered: 0,
            totalBytesDelivered: 0
        };
        this.panelRows = [];

        if (this.chromeless) {
            initChromeless();
        } else {
            initNormal();
        }
    };

    const initChromeless = () => {
        buildPanelRows();
        MetricsDashboardService.initialize(true)
            .finally(() => {
                this.loadingIndicator.show = false;
            });
    };

    const initNormal = () => {
        setupBreadcrumbs();
        setupToolbar();
        buildPanelRows();

        MetricsDashboardService.initialize()
            .catch((errorData: JS5Object) => {
                console.error(`MetricsDashboardController.$onInit():`);
                console.error(errorData);

                NotificationService.createFailureNotification(
                    `Unable to fetch metrics data.`,
                    _.get(errorData, 'data.message', errorData),
                    true,
                    -1);
            }).finally(() => {
                this.loadingIndicator.show = false;
            });
    };

}

angular.module('prism-ui.metricsDashboard').component('metricsDashboard', {
    templateUrl: 'dashboard/metrics/metrics-dashboard-template.html',
    controller: MetricsDashboardController,
    bindings: {
    }
});
